import {
  GET_CROSSSELL_START,
  GET_CROSSSELL_SUCCESS,
  GET_CROSSSELL_FAILURE,
  GET_CROSSSELL_RESET,
  GET_CITY_START,
  GET_CITY_SUCCESS,
  GET_CITY_FAILURE,
  GET_CITY_RESET,
  EXPORT_CROSS_SELL_REPORT,
  EXPORT_CROSS_SELL_REPORT_SUCCESS,
  EXPORT_CROSS_SELL_REPORT_FAILED,
} from './actiontypes'

// Cross-sell list actions
export const getCrossSellStart = (payload) => ({
  type: GET_CROSSSELL_START,
  payload,
})

export const getCrossSellSuccess = payload => ({
  type: GET_CROSSSELL_SUCCESS,
  payload,
})

export const getCrossSellFailure = error => ({
  type: GET_CROSSSELL_FAILURE,
  payload: error,
})

export const getCrossSellReset = () => ({
  type: GET_CROSSSELL_RESET,
})

// City actions
export const getCityStart = () => ({
  type: GET_CITY_START,
})

export const getCitySuccess = payload => ({
  type: GET_CITY_SUCCESS,
  payload,
})

export const getCityFailure = error => ({
  type: GET_CITY_FAILURE,
  payload: error,
})

export const getCityReset = () => ({
  type: GET_CITY_RESET,
})

// Export excel actions
export const exportCrossSellReport = (payload) => ({
  type: EXPORT_CROSS_SELL_REPORT,
  payload,
})

export const exportCrossSellReportSuccess = (payload) => ({
  type: EXPORT_CROSS_SELL_REPORT_SUCCESS,
  payload,
})

export const exportCrossSellReportFailed = (payload) => ({
  type: EXPORT_CROSS_SELL_REPORT_FAILED,
  payload,
})